import React from "react";
import { motion } from "framer-motion";

const PURPLE_GRADIENT = "linear-gradient(16.66deg, #9E85DD 25%, #7B39EC 59.86%)";

const DailyRentalCard = ({ car, onBook, winWidth, freeKm }) => {
  const imgW = winWidth >= 1880 ? 193 : winWidth >= 1536 ? 275 : winWidth >= 1280 ? 250 : 225;
  const imgH = Math.round(imgW * (155 / 247));

  const price = car.rentPerHr != null ? Number(car.rentPerHr) : null;

  return (
    <motion.article
      layout
      className={`relative bg-white border border-[#E5E7EB] rounded-xl shadow-[0px_8px_13px_rgba(212,184,184,0.07)] flex items-center justify-between p-5 overflow-hidden transition-all min-w-0 ${car.isSoldOut ? "opacity-60" : ""}`}
    >
      {/* Left: details */}
      <div className="flex flex-col gap-[14.7px] items-start min-w-0 flex-1">
        {/* Name + body type */}
        <div className="flex flex-col gap-[7.4px] items-start w-full">
          <span className="text-[#252525] text-[22px] font-semibold font-['Outfit'] leading-[1.2] tracking-[0.4px] text-left w-full">
            {car.name}
          </span>
          <div className="flex items-center gap-2 flex-wrap">
            {car.bodyTypeText && (
              <span className="px-2 py-0.5 bg-[#F9FAFB] border border-[#F3F3F9] rounded text-[#1D4ED8] text-xs font-semibold font-['Outfit'] uppercase tracking-[1px]">
                {car.bodyTypeText}
              </span>
            )}
          </div>
        </div>

        {/* Specs pills */}
        <div className="flex items-center gap-[7.4px] min-[1880px]:gap-[5.2px] flex-wrap">
          <span className="px-[7.4px] py-[7.4px] min-[1880px]:px-[5.2px] min-[1880px]:py-[5.2px] bg-[#F9FAFB] border border-[#E5E7EB] rounded-[7.4px] min-[1880px]:rounded-[5.2px] text-[#111827] text-[12.9px] min-[1880px]:text-[9px] font-semibold font-['Outfit'] whitespace-nowrap">
            {car.seater} Seats
          </span>
          <span className="px-[7.4px] py-[7.4px] min-[1880px]:px-[5.2px] min-[1880px]:py-[5.2px] bg-[#F9FAFB] border border-[#E5E7EB] rounded-[7.4px] min-[1880px]:rounded-[5.2px] text-[#111827] text-[12.9px] min-[1880px]:text-[9px] font-semibold font-['Outfit'] whitespace-nowrap">
            {car.transmissionTypeText}
          </span>
          <span className="px-[7.4px] py-[7.4px] min-[1880px]:px-[5.2px] min-[1880px]:py-[5.2px] bg-[#F9FAFB] border border-[#E5E7EB] rounded-[7.4px] min-[1880px]:rounded-[5.2px] text-[#111827] text-[12.9px] min-[1880px]:text-[9px] font-semibold font-['Outfit'] whitespace-nowrap">
            {car.fuelTypeText}
          </span>
        </div>

        {/* Pricing */}
        <div className="flex flex-col gap-[5.5px] items-start">
          <span className="text-[#6B7280] text-[11px] font-medium font-['Outfit'] tracking-[0.22px]">
            Starting from
          </span>
          {price != null ? (
            <div className="flex items-end gap-1">
              <span className="text-[#CD2525] text-[29.5px] font-bold font-['Outfit'] tracking-[-0.29px] leading-none">
                ₹{price.toLocaleString("en-IN")}
              </span>
              <span className="text-[#CD2525] text-[14px] font-semibold font-['Outfit'] mb-[3px]">
                /hr
              </span>
            </div>
          ) : (
            <span className="text-[#9CA3AF] text-[16px] font-medium font-['Outfit']">Price unavailable</span>
          )}
          <p className="text-[#6B7280] text-[11px] font-bold font-['Outfit'] tracking-[0.22px] text-left">
            {car.baseFare != null && car.taxAmount != null && (
              <span>₹{(Number(car.baseFare) + Number(car.taxAmount)).toLocaleString("en-IN")} · </span>
            )}
            Incl. Taxes &amp; Excl. Fees
          </p>
        </div>

        {/* Free km + extra km charge */}
        {car.extraKmRental != null && freeKm > 0 && (
          <p className="text-[#374151] text-[12px] font-medium font-['Outfit'] tracking-[0.22px] text-left">
            ₹{Number(car.extraKmRental).toLocaleString("en-IN")}/km after{" "}
            <span className="text-[#1D4ED8] font-semibold">{freeKm} km</span> limit
          </p>
        )}
      </div>

      {/* Right: image + Book Now */}
      <div className="flex flex-col items-end gap-2 shrink-0 ml-3">
        <div style={{ width: imgW, height: imgH }}>
          <img
            src={car.imageUrl || "/assets/sample.png"}
            alt={car.name}
            className="w-full h-full object-contain"
          />
        </div>
        <button
          disabled={car.isSoldOut}
          onClick={() => onBook(car)}
          className={`h-[38px] px-[18px] rounded-lg text-[15.2px] font-medium font-['Outfit'] tracking-[0.43px] text-white border whitespace-nowrap ${car.isSoldOut ? "bg-gray-200 text-gray-400 border-gray-200" : "border-[#6595FF] shadow-[0px_10.84px_13px_rgba(26,86,219,0.2)]"}`}
          style={!car.isSoldOut ? { backgroundImage: PURPLE_GRADIENT } : undefined}
        >
          {car.isSoldOut ? "Sold Out" : "Book Now"}
        </button>
      </div>
    </motion.article>
  );
};

export default DailyRentalCard;
